export var CullMode;
(function (CullMode) {
    CullMode[CullMode["Off"] = 0] = "Off";
    CullMode[CullMode["Front"] = 1] = "Front";
    CullMode[CullMode["Back"] = 2] = "Back";
})(CullMode || (CullMode = {}));
export var FrontFace;
(function (FrontFace) {
    FrontFace[FrontFace["CW"] = 0] = "CW";
    FrontFace[FrontFace["CCW"] = 1] = "CCW";
})(FrontFace || (FrontFace = {}));
